export const CreditCardIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="18" viewBox="0 0 24 18">
        <g id="checkout-icon" transform="translate(0 -3)">
            <path id="Path_10" data-name="Path 10" d="M19,3H5A5.006,5.006,0,0,0,0,8H24a5.006,5.006,0,0,0-5-5Z"/>
            <path id="Path_11" data-name="Path 11" d="M0,16a5.006,5.006,0,0,0,5,5H19a5.006,5.006,0,0,0,5-5V10H0Zm7-.5A1.5,1.5,0,1,1,5.5,14,1.5,1.5,0,0,1,7,15.5"/>
        </g>
    </svg>
)